import { render, staticRenderFns } from "./valuesList.vue?vue&type=template&id=f7b47006&"
import script from "./valuesList.vue?vue&type=script&lang=js&"
export * from "./valuesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports